// App.jsx
import React, { useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header.jsx';
import MainContent from './components/MainContext.jsx';
import Footer from './components/Footer.jsx';
import useScrollFade from './components/useScrollFade.jsx';
import './App.css';

const App = () => {
	const headerRef = useRef(null);
	const experienceRef = useRef(null);
	const educationRef = useRef(null);
	const projectsRef = useRef(null);
	const skillsRef = useRef(null);

	useScrollFade(headerRef);
	useScrollFade(experienceRef);
	useScrollFade(educationRef);
	useScrollFade(projectsRef);
	useScrollFade(skillsRef);

	return (
		<div className="App container">
			<Header ref={headerRef} />
			<MainContent
				experienceRef={experienceRef}
				educationRef={educationRef}
				projectsRef={projectsRef}
				skillsRef={skillsRef}
			/>
			<Footer />
		</div>
	);
};

export default App;
